export default __webpack_public_path__ + "static/media/progressbar_rounded_red.2238e659.svg";